export default __webpack_public_path__ + "static/media/creativity.135af12f.svg";